import { render, staticRenderFns } from "./Cardapio.vue?vue&type=template&id=450a43b7&"
import script from "./Cardapio.vue?vue&type=script&lang=js&"
export * from "./Cardapio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports